import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/icons/Download01Icon.tsx
var i = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M2 16.2002V15C2 14.4477 2.44772 14 3 14C3.55229 14 4 14.4477 4 15V16.2002C4 17.0566 4.00035 17.6388 4.03711 18.0889C4.07293 18.5273 4.13806 18.7518 4.21778 18.9082C4.40951 19.2845 4.71555 19.5905 5.0918 19.7822C5.24825 19.8619 5.47274 19.9271 5.91113 19.9629C6.36116 19.9997 6.94339 20 7.79981 20H16.2002C17.0566 20 17.6388 19.9997 18.0889 19.9629C18.5273 19.9271 18.7518 19.8619 18.9082 19.7822C19.2845 19.5905 19.5905 19.2845 19.7822 18.9082C19.8619 18.7518 19.9271 18.5273 19.9629 18.0889C19.9997 17.6388 20 17.0566 20 16.2002V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V16.2002C22 17.0237 22.001 17.7016 21.9561 18.252C21.9101 18.814 21.8117 19.3311 21.5645 19.8164C21.181 20.5689 20.5689 21.181 19.8164 21.5645C19.3311 21.8117 18.814 21.9101 18.252 21.9561C17.7016 22.001 17.0237 22 16.2002 22H7.79981C6.9763 22 6.29843 22.001 5.74805 21.9561C5.18598 21.9101 4.66892 21.8117 4.1836 21.5645C3.43109 21.181 2.81902 20.5689 2.43555 19.8164C2.18828 19.3311 2.08988 18.814 2.04395 18.252C1.99898 17.7016 2 17.0237 2 16.2002ZM11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V12.5859L16.293 9.29297C16.6835 8.90244 17.3165 8.90244 17.707 9.29297C18.0976 9.68349 18.0976 10.3165 17.707 10.707L12.707 15.707C12.3165 16.0976 11.6835 16.0976 11.293 15.707L6.29297 10.707C5.90245 10.3165 5.90245 9.68349 6.29297 9.29297C6.6835 8.90244 7.31651 8.90244 7.70703 9.29297L11 12.5859V3Z",
		fill: "currentColor"
	})
}), a = {
	12: {
		Artwork: i,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V10.7998C14.75 11.3475 14.751 11.8037 14.7207 12.1748C14.6897 12.5545 14.6219 12.9109 14.4502 13.248C14.1866 13.7655 13.7655 14.1865 13.2481 14.4502C12.9109 14.6219 12.5545 14.6897 12.1748 14.7207C11.8037 14.751 11.3475 14.75 10.7998 14.75H5.2002C4.65251 14.75 4.19633 14.751 3.8252 14.7207C3.44546 14.6897 3.0891 14.6219 2.75196 14.4502C2.23454 14.1865 1.81346 13.7655 1.54981 13.248C1.3781 12.9109 1.31034 12.5545 1.2793 12.1748C1.24898 11.8037 1.25 11.3475 1.25 10.7998V10C1.25 9.58579 1.58579 9.25 2 9.25C2.41422 9.25 2.75 9.58579 2.75 10V10.7998C2.75 11.3722 2.75024 11.7569 2.77442 12.0527C2.79788 12.3397 2.84057 12.4768 2.88672 12.5674C3.00655 12.8025 3.19751 12.9935 3.43262 13.1133C3.5232 13.1594 3.66029 13.2021 3.94727 13.2256C4.24314 13.2498 4.62776 13.25 5.2002 13.25H10.7998C11.3722 13.25 11.7569 13.2498 12.0527 13.2256C12.3397 13.2021 12.4768 13.1594 12.5674 13.1133C12.8025 12.9935 12.9935 12.8025 13.1133 12.5674C13.1594 12.4768 13.2021 12.3397 13.2256 12.0527C13.2498 11.7569 13.25 11.3722 13.25 10.7998V10C13.25 9.58579 13.5858 9.25 14 9.25Z",
				fill: "currentColor"
			}), /* @__PURE__ */ n("path", {
				d: "M8 1.25C8.41422 1.25 8.75 1.58579 8.75 2V8.18945L10.8027 6.13672C11.0956 5.84383 11.5704 5.84383 11.8633 6.13672C12.1562 6.42961 12.1562 6.90437 11.8633 7.19727L8.53028 10.5303C8.23738 10.8232 7.76262 10.8232 7.46973 10.5303L4.13672 7.19727C3.84383 6.90437 3.84383 6.42961 4.13672 6.13672C4.42962 5.84383 4.90438 5.84383 5.19727 6.13672L7.25 8.18945V2C7.25 1.58579 7.58579 1.25 8 1.25Z",
				fill: "currentColor"
			})]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: i,
		width: 20,
		height: 20
	},
	24: {
		Artwork: i,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, tone: r = "default", className: i, ...o }) => /* @__PURE__ */ n(e, {
	source: a[t],
	monochrome: !0,
	className: ["pf-icon-" + r, i].filter(Boolean).join(" "),
	...o
});
//#endregion
export { o as Download01Icon };
